'use client';

import Footer from '@/components/Footer';
import Navigation from '@/components/Navigation';
import { Timeline } from '@/components/ui/timeline';
import Image from 'next/image';
import { useState } from 'react';

// Image component with fallback
const ImageWithFallback = ({ 
  src, 
  alt, 
  className 
}: { 
  src: string; 
  alt: string; 
  className?: string;
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="relative overflow-hidden rounded-lg">
      <Image
        src={imgSrc}
        alt={alt}
        width={500}
        height={500}
        className={`${className} ${isLoading ? 'blur-sm' : 'blur-0'} transition-all duration-300`}
        onError={() => {
          setImgSrc('/images/placeholder/property.png');
        }}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
};

export default function AboutClient() {
  const data = [
    {
      title: "2024",
      content: (
        <div>
          <p className="mb-8 text-xs font-normal text-neutral-800 md:text-sm dark:text-neutral-200">
            Continued expansion of our service portfolio and strengthened partnerships with major Qatari developers and government institutions.
          </p>
          <div className="grid grid-cols-2 gap-4">
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409170/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.19.26_PM_3_cq0bcr.jpg"
              alt="Property Management Services"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409170/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.19.26_PM_2_gj3weg.jpg"
              alt="MEP Services"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409171/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.19.27_PM_2_rh1elz.jpg"
              alt="HVAC Services"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409173/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.19.28_PM_5_qrxio7.jpg"
              alt="Fit-out Services"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
          </div>
        </div>
      ),
    },
    {
      title: "2019-2023",
      content: (
        <div>
          <p className="mb-8 text-xs font-normal text-neutral-800 md:text-sm dark:text-neutral-200">
            Major expansion period with significant growth in our client base, including partnerships with Waldorf Astoria, Ministry of Interior, and Private Engineering Office.
          </p>
          <p className="mb-8 text-xs font-normal text-neutral-800 md:text-sm dark:text-neutral-200">
            Launched comprehensive MEP, HVAC, and civil works services, establishing ourselves as a one-stop solution for property management needs across Qatar.
          </p>
          <div className="grid grid-cols-2 gap-4">
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409173/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.19.28_PM_3_ejxrna.jpg"
              alt="Government Projects"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409174/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.20.03_PM_1_cwmg0m.jpg"
              alt="Commercial Properties"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409175/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.20.04_PM_1_z9bzpx.jpg"
              alt="Luxury Hotels"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409174/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.20.03_PM_qzcuyk.jpg"
              alt="Residential Compounds"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
          </div>
        </div>
      ),
    },
    {
      title: "2011-2018",
      content: (
        <div>
          <p className="mb-4 text-xs font-normal text-neutral-800 md:text-sm dark:text-neutral-200">
            Founded Eshhar Real Estate as a member of the Eshhar Group, registered under CR No. 94697 with Qatar&apos;s Ministry of Commerce.
          </p>
          <div className="mb-8">
            <div className="flex items-center gap-2 text-xs text-neutral-700 md:text-sm dark:text-neutral-300">
              ✅ Established core facility management services
            </div>
            <div className="flex items-center gap-2 text-xs text-neutral-700 md:text-sm dark:text-neutral-300">
              ✅ Built experienced workforce in real estate and maintenance
            </div>
            <div className="flex items-center gap-2 text-xs text-neutral-700 md:text-sm dark:text-neutral-300">
              ✅ Developed comprehensive service portfolio
            </div>
            <div className="flex items-center gap-2 text-xs text-neutral-700 md:text-sm dark:text-neutral-300">
              ✅ Earned trust of early government and corporate clients
            </div>
            <div className="flex items-center gap-2 text-xs text-neutral-700 md:text-sm dark:text-neutral-300">
              ✅ Established reliable operations with high safety standards
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409765/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.20.25_PM_3_xqlxww.jpg"
              alt="Company Foundation"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409581/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.20.24_PM_4_iz7naw.jpg"
              alt="Early Projects"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409581/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.20.24_PM_3_qjorvy.jpg"
              alt="Team Building"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
            <ImageWithFallback
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1759409581/Eshhar%20Real%20Estate/images/project%20gallery/WhatsApp_Image_2025-09-25_at_4.20.24_PM_2_ergck2.jpg"
              alt="Service Development"
              className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60"
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <Navigation />
      <main className="min-h-screen pt-20">
        {/* Hero Section */}
        <div className="relative pt-12 pb-6 px-4 text-center bg-white dark:bg-dark-primary">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6">
              About Eshhar Real Estate
            </h1>
       
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto rounded-full"></div>
          </div>
        </div>

        {/* Company Overview */}
        <section className=" bg-white dark:bg-dark-primary">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-2xl font-bold mb-6 dark:text-white">Trusted Experts in Real Estate & Integrated Facility Services</h2>
              <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
                Since 2011, Eshhar Real Estate has been delivering excellence in Qatar&apos;s real estate and maintenance sectors.
                As a proud member of the Eshhar Group and certified by the Ministry of Commerce (CR No. 94697), we specialize
                in comprehensive property solutions—from MEP, HVAC, and civil works to pest control, cleaning, and fit-out services.
              </p>
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section className="py-8 ">
          <div className="relative w-full overflow-clip">
            <Timeline data={data} />
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

